/**
 * 接口域名的管理
 */
const base = {
  // // 开发环境
  // baseURL: 'http://192.168.10.45:8066' // 彭灿
  baseURL: 'https://zjruika.com/crm' // 腾讯云
}
export default base;



// WEBPACK FOOTER //
// ./src/api/base.js